import { DocumentSubType } from '@model/ftf-api.model';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DocumentSubTypesState } from '../reducers/document-subtypes.reducer';

export const selectDocumentSubTypesState = createFeatureSelector<DocumentSubTypesState>('documentSubTypes');

export const selectDocumentSubTypes = createSelector(selectDocumentSubTypesState, (state: DocumentSubTypesState) => state.subtypes);

export const selectDocumentSubTypesError = createSelector(selectDocumentSubTypesState, (state: DocumentSubTypesState) => state.error);

export const selectIsDocumentSubTypesLoaded = createSelector(selectDocumentSubTypesState, (state: DocumentSubTypesState) => state.isLoaded);

export const selectDocumentSubTypesMap = createSelector(selectDocumentSubTypes, (subtypes) =>
  subtypes.reduce((map: Record<string, DocumentSubType>, subtype) => {
    if (subtype.id) {
      map[`${subtype.id}`] = subtype;
    }
    return map;
  }, {})
);

export const selectDocumentSubTypeById = (id: string) =>
  createSelector(selectDocumentSubTypes, (subtypes) => subtypes.find((s) => s.id?.toString() === id));
